import { AdminTemplate, EneryaListingPage } from "../../components";

export const Enerya = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "Enerya Mutabakat İşlemleri",
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
        >
            <EneryaListingPage />
        </AdminTemplate>
    );
};
